import React, { useState } from "react";

const INITIAL_DOCS = [
  {
    id: 1,
    type: "Đề xuất",
    typeColor: "bg-blue-50 text-blue-700 border-blue-200",
    code: "DXNV-ICOOL-22092026023...",
    title: "BTM - Đề xuất thiết bị chuyển đổi hdmi sang vga...",
    time: "4 phút trước",
  },
  {
    id: 2,
    type: "ĐNTT",
    typeColor: "bg-blue-50 text-blue-700 border-blue-200",
    code: "DNTT-ICOOL-08072026101905",
    title: "c7-TN-TT tiền mua bếp chiên - Làm gia",
    time: "7 phút trước",
  },
  {
    id: 3,
    type: "ĐNTT",
    typeColor: "bg-blue-50 text-blue-700 border-blue-200",
    code: "DNTT-ICOOL-16092026100546",
    title: "P.HH- Thanh toán quỹ nóng kỹ 16/92026",
    time: "9 phút trước",
  },
  {
    id: 4,
    type: "Lịch chi",
    typeColor: "bg-amber-50 text-amber-700 border-amber-200",
    code: "LTC180920260749341",
    title: "P.HH- Thanh toán quỹ nóng kỹ 16/92026",
    time: "9 phút trước",
  },
  {
    id: 5,
    type: "ĐNTT",
    typeColor: "bg-blue-50 text-blue-700 border-blue-200",
    code: "DNTT-ICOOL-22092026033831",
    title: "TK -THANH TOÁN ĐÁ BI TỪ NGÀY 14/09=>20/...",
    time: "26 phút trước",
  },
];

export default function RecentDocuments() {
  const [docs, setDocs] = useState(INITIAL_DOCS);
  const [activePage, setActivePage] = useState(1);

  const handleRemove = (id) => {
    setDocs((prev) => prev.filter((d) => d.id !== id));
  };

  const handleClearAll = () => {
    setDocs([]);
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200/80 p-4 space-y-4">
      {/* Header bar */}
      <div className="flex items-center justify-between pb-2 border-b border-gray-100">
        <div className="flex items-center gap-2">
          <h2 className="text-sm md:text-base font-bold text-gray-900">
            Chứng từ xem gần đây
          </h2>
          <span className="bg-gray-100 text-gray-700 text-xs font-semibold px-2 py-0.5 rounded-full border border-gray-200">
            {docs.length}
          </span>
        </div>

        <button
          onClick={handleClearAll}
          title="Xóa tất cả xem gần đây"
          className="text-gray-400 hover:text-red-600 p-1.5 hover:bg-red-50 rounded-lg transition-colors"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
        </button>
      </div>

      {/* List of Document Cards */}
      <div className="space-y-2.5">
        {docs.length === 0 ? (
          <div className="py-8 text-center text-xs text-gray-400 font-medium">
            Không có chứng từ nào gần đây
          </div>
        ) : (
          docs.map((item) => (
            <div
              key={item.id}
              className="p-3 bg-white hover:bg-blue-50/30 rounded-lg border border-gray-200/80 hover:border-blue-200 transition-all duration-150 relative group shadow-2xs"
            >
              <button
                onClick={() => handleRemove(item.id)}
                className="absolute top-2.5 right-2.5 text-gray-300 hover:text-gray-600 p-0.5 rounded-full hover:bg-gray-100 transition-colors"
              >
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>

              <div className="pr-6 space-y-1">
                <div className="flex items-center gap-2">
                  <span
                    className={`text-[10px] font-bold px-1.5 py-0.2 rounded border ${item.typeColor}`}
                  >
                    {item.type}
                  </span>
                  <span className="text-xs font-bold text-blue-700 hover:underline cursor-pointer truncate">
                    {item.code}
                  </span>
                </div>

                <p className="text-xs text-gray-600 line-clamp-2 leading-relaxed">
                  {item.title}
                </p>

                <div className="flex items-center gap-1 text-[11px] text-gray-400 pt-0.5">
                  <svg className="w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span>{item.time}</span>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Footer Pagination */}
      <div className="flex items-center justify-center gap-1 pt-2">
        {[1, 2, 3, 4].map((page) => (
          <button
            key={page}
            onClick={() => setActivePage(page)}
            className={`w-7 h-7 text-xs rounded-md font-semibold transition-colors ${
              activePage === page
                ? "bg-blue-600 text-white shadow-2xs"
                : "bg-gray-50 text-gray-600 hover:bg-gray-100 border border-gray-200"
            }`}
          >
            {page}
          </button>
        ))}
      </div>
    </div>
  );
}
